export default "__VITE_ASSET__TOo6nES1__"